import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
export const announcement = createCrudVuexModule({
  namespaced: true,
  path: "/announcement",
});

export const managementAnnouncement = createCrudVuexModule({
  namespaced: true,
  path: "/management/announcement",
  options: { localizedFields: ["name", "description", "detail"] },
});

export const organizationAnnouncement = createCrudVuexModule({
  namespaced: true,
  path: "/organization-announcement",
  options: { localizedFields: ["name", "description", "detail"] },

  state: {
    myOrganizationAnnouncements: undefined,
  },
  mutations: {
    myOrganizationAnnouncements: (state, value) => (state.myOrganizationAnnouncements = value),
  },
  getters: {
    myOrganizationAnnouncements: (state) => state.myOrganizationAnnouncements,
  },
  actions: {
    async fetchUserAccessableAnnouncements({ commit }, pagination, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("myOrganizationAnnouncements", undefined);
        }
        const response = await rest.post(`/organization-announcement/my/paginate`, { pagination });
        commit("myOrganizationAnnouncements", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
